export { default } from "./TextConfig";
